import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import $ from 'jquery';

import { PAGE_ESTIMATION, PAGE_HOME, PAGE_OFFER, PAGE_THREATS } from '../../../config/pages';

import HomeBox from './HomeBox';
import HomeLink from './HomeLink';

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mouse: false,
            mouseElem: null,
            mousePercent: 0.0
        };
        this.mouseMove = this.mouseMove.bind(this);
        this.mouseOut = this.mouseOut.bind(this);
        this.boxClick = this.boxClick.bind(this);
        this.scrollToContent = this.scrollToContent.bind(this);
    }

    componentDidMount() {
        $('.container-home').on('mousemove', this.mouseMove);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.page !== nextProps.page && nextProps.page !== PAGE_HOME) {
            this.reset();
        }
    }

    componentWillUnmount() {
        $('.container-home').off('mousemove');
    }

    mouseMove(e) {
        if (this.props.page !== PAGE_HOME) {
            this.reset();
            return;
        }

        if (this.props.breakpoint === 'phone' || this.props.breakpoint === 'tablet') {
            this.reset();
            return;
        }

        const cursorX = e.pageX;
        const windowWidth = $(window).width();
        const percent = (2 * (cursorX / windowWidth)) - 1.0;

        this.setState({
            mouse: true,
            mouseElem: (percent <= 0) ? PAGE_THREATS : PAGE_OFFER,
            mousePercent: Math.abs(percent)
        });
    }

    mouseOut() {
        this.reset();
    }

    boxClick(type) {
        this.props.openPage(type);
    }

    reset() {
        this.setState({
            mouse: false,
            mouseElem: null,
            mousePercent: 0.0
        });
    }

    scrollToContent() {
        if ($('.container-threats-security-page').length > 0) {
            const { breakpoint } = this.props;
            const headerPlaceholderHeight = $('.container-header-placeholder').outerHeight(true);
            const headerHeight = (breakpoint === 'widescreen' || breakpoint === 'desktop') ? 50 : 40;
            let contentTop = 600;
            if (breakpoint === 'laptop') {
                contentTop = 428;
            } else if (breakpoint === 'tablet') {
                contentTop = 300;
            } else if (breakpoint === 'phone') {
                contentTop = 100;
            }
            const posTop = (contentTop + headerPlaceholderHeight) - headerHeight;
            $('html, body').animate({
                scrollTop: posTop
            }, 1000);
        }
    }

    render() {
        const { mouse, mouseElem, mousePercent } = this.state;
        const {
            t, page, noTransition, preloaderDone
        } = this.props;
        const elemClassName = cx('container-home', {
            open: page !== PAGE_HOME,
            'no-transition': noTransition
        });
        const ctaLeft = [{ type: PAGE_THREATS, text: t(`home.${ PAGE_THREATS }.excerpt.button`) }];
        const ctaRight = [
            { type: PAGE_OFFER, text: t(`home.${ PAGE_OFFER }.excerpt.button`) },
            { type: PAGE_ESTIMATION, text: t(`home.${ PAGE_OFFER }.excerpt.button_pricing`) }
        ];

        return (
            <div className={ elemClassName } id={ elemClassName } onMouseOut={ this.mouseOut }>
                <HomeBox
                  ctas={ ctaLeft }
                  t={ t }
                  page={ page }
                  type={ PAGE_THREATS }
                  mouse={ mouse }
                  mouseActive={ mouseElem === PAGE_THREATS }
                  mousePercent={ mousePercent }
                  boxClick={ this.boxClick }
                  scrollToContent={ this.scrollToContent }
                  noTransition={ noTransition }
                />
                <HomeBox
                  ctas={ ctaRight }
                  t={ t }
                  page={ page }
                  type={ PAGE_OFFER }
                  mouse={ mouse }
                  mouseActive={ mouseElem === PAGE_OFFER }
                  mousePercent={ mousePercent }
                  boxClick={ this.boxClick }
                  scrollToContent={ this.scrollToContent }
                  noTransition={ noTransition }
                />
                {
                    page === PAGE_HOME && (
                        <HomeLink
                          t={ t }
                          preloaderDone={ preloaderDone }
                        />
                    )
                }
            </div>
        );
    }
}

Home.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    page: PropTypes.string.isRequired,
    breakpoint: PropTypes.string.isRequired,
    noTransition: PropTypes.bool.isRequired,
    preloaderDone: PropTypes.bool.isRequired
};

export default Home;



// WEBPACK FOOTER //
// ./src/components/content/home/Home.jsx